export enum UIStepFunctionCreateOrEditFieldName {
  Name = 'name',
  IntegrationOperatorType = 'integrationOperatorType',
  SubscribedEvents = 'subscribedEvents',
  PublishedEventOnSuccess = 'publishedEventsOnSuccess',
  PublishedEventOnFailure = 'publishedEventsOnFailure',
  ProjectModel = 'projectModel',
  Code = 'code',
}
